module.exports = __webpack_public_path__ + "static/img/bookmark.d457e7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/student-smart/bookmark.jpg
// module id = G/Zm
// module chunks = 1